// Actions
export const setSuppliers = ({ commit }, payload) => {
  commit('SET_SUPPLIERS', payload)
}
export const addSuppliers = ({ commit }, payload) => {
  commit('ADD_SUPPLIERS', payload)
}
export const setSuppliersLoading = ({ commit }, payload) => {
  commit('SET_SUPPLIERS_LOADING', payload)
}

export const setBillsToPay = ({ commit }, payload) => {
  commit('SET_BILLS_TO_PAY', payload)
}
export const addBillsToPay = ({ commit }, payload) => {
  commit('ADD_BILLS_TO_PAY', payload)
}
export const setBillsToPayLoading = ({ commit }, payload) => {
  commit('SET_BILLS_TO_PAY_LOADING', payload)
}

export const setDepartments = ({ commit }, payload) => {
  commit('SET_DEPARTMENTS', payload)
}
export const addDepartments = ({ commit }, payload) => {
  commit('ADD_DEPARTMENTS', payload)
}
export const setDepartmentsLoading = ({ commit }, payload) => {
  commit('SET_DEPARTMENTS_LOADING', payload)
}

export const setCategories = ({ commit }, payload) => {
  commit('SET_CATEGORIES', payload)
}
export const addCategories = ({ commit }, payload) => {
  commit('ADD_CATEGORIES', payload)
}
export const setCategoriesLoading = ({ commit }, payload) => {
  commit('SET_CATEGORIES_LOADING', payload)
}

export const setBillsStatus = ({ commit }, payload) => {
  commit('SET_BILLS_STATUS', payload)
}
export const setFornecedores = ({ commit }, payload) => {
  commit('SET_FORNECEDORES', payload)
}
export const addFornecedores = ({ commit }, payload) => {
  commit('ADD_FORNECEDORES', payload)
}
export const setFornecedoresLoading = ({ commit }, payload) => {
  commit('SET_FORNECEDORES_LOADING', payload)
}

export const setBillsToReceive = ({ commit }, payload) => {
  commit('SET_BILLS_TO_RECEIVE', payload)
}
export const addBillsToReceive = ({ commit }, payload) => {
  commit('ADD_BILLS_TO_RECEIVE', payload)
}
export const setBillsToReceiveLoading = ({ commit }, payload) => {
  commit('SET_BILLS_TO_RECEIVE_LOADING', payload)
}

export const setServico = ({ commit }, payload) => {
  commit('SET_SERVICO', payload)
}
export const addServico = ({ commit }, payload) => {
  commit('ADD_SERVICO', payload)
}
export const setServicoLoading = ({ commit }, payload) => {
  commit('SET_SERVICO_LOADING', payload)
}

export const setObservationsBillsToReceive = ({ commit }, payload) => {
  commit('SET_OBSERVATIONS_BILLS_TO_RECEIVE', payload)
}
export const addObservationsBillsToReceive = ({ commit }, payload) => {
  commit('ADD_OBSERVATIONS_BILLS_TO_RECEIVE', payload)
}
export const setObservationsBillsToReceiveLoading = ({ commit }, payload) => {
  commit('SET_OBSERVATIONS_BILLS_TO_RECEIVE_LOADING', payload)
}

export const setPjs = ({ commit }, payload) => {
  commit('SET_PJS', payload)
}
export const addPjs = ({ commit }, payload) => {
  commit('ADD_PJS', payload)
}
export const setPjsLoading = ({ commit }, payload) => {
  commit('SET_PJS_LOADING', payload)
}
export const setFaturamentoAnexos = ({ commit }, payload) => {
  commit('SET_FATURAMENTO_ANEXOS', payload)
}
export const addFaturamentoAnexos = ({ commit }, payload) => {
  commit('ADD_FATURAMENTO_ANEXOS', payload)
}
export const setFaturamentoAnexosLoading = ({ commit }, payload) => {
  commit('SET_FATURAMENTO_ANEXOS_LOADING', payload)
}

export const setSolicitations = ({ commit }, payload) => {
  commit('SET_SOLICITATIONS', payload)
}
export const addSolicitations = ({ commit }, payload) => {
  commit('ADD_SOLICITATIONS', payload)
}
export const setSolicitationsLoading = ({ commit }, payload) => {
  commit('SET_SOLICITATIONS_LOADING', payload)
}
export const setSolicitationsPendingCount = ({ commit }, payload) => {
  commit('SET_SOLICITATIONS_PENDING_COUNT', payload)
}
export const setSolicitationsPendingCountLoading = ({ commit }, payload) => {
  commit('SET_SOLICITATIONS_PENDING_COUNT_LOADING', payload)
}

export const setFiliais = ({ commit }, payload) => {
  commit('SET_FILIAIS', payload)
}
export const addFiliais = ({ commit }, payload) => {
  commit('ADD_FILIAIS', payload)
}
export const setFiliaisLoading = ({ commit }, payload) => {
  commit('SET_FILIAIS_LOADING', payload)
}

